export const RANKING_LABEL_SORT_OPTIONS = {
  ASC: 'ASC',
  DESC: 'DESC',
};
export const MIN_SCREENERS_ANSWER_LIMIT = 2;

export const QUOTA_MATCHERS = {
  EQUAL: 'EQUAL',
  GREATER_THAN_EQUAL: 'GREATER_THAN_EQUAL',
};
